import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { BookButton } from './BookButton';
import { Reveal } from './Reveal';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative flex min-h-[100svh] items-center overflow-hidden bg-navy pb-20 pt-32 md:pt-36" data-id="element-44" data-mp="9lv1krql6hwd">
      <div className="absolute inset-0" data-id="element-45" data-mp="129h19owp12dy">
        <PhotoPlaceholder variant="background" description="Documentary photo: a veteran in civilian clothes seated at a kitchen table, mid-conversation with a team member, papers between them. Natural window light." alt="A veteran sitting across the table from a Veterans For Life team member, talking through his claim." supplySize="2880 × 1800 px or larger" data-id="element-46" data-mp="128fo9ew4a5tl" />
        <div aria-hidden="true" className="absolute inset-0 z-10 bg-navy/80" data-id="element-47" data-mp="3d33gb2q0p1mv" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-10" data-id="element-48" data-mp="381nv9anuav4h">
        <Reveal className="max-w-3xl" data-id="element-49" data-mp="3j896f9neq5ny">
          <p className="flex items-center gap-3 text-sm font-semibold tracking-[0.2em] text-gold" data-id="element-50" data-mp="3j9ahvf8c4u67">
            <span aria-hidden="true" className="h-px w-10 bg-gold" data-id="element-51" data-mp="3o6u7tceeavdz" />
            VETERAN OWNED. VETERAN RUN.
          </p>
          <h1 id="hero-heading" className="mt-6 font-serif text-5xl font-semibold leading-[1.08] text-paper md:text-6xl lg:text-7xl" data-id="element-52" data-mp="39cpain8uf6z7">
            You earned it. We'll help you claim it.
          </h1>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-paper/85 md:text-xl" data-id="element-53" data-mp="358zq89z7bbjz">
            Trusted by fellow vets. Built by those who've been there. We sit down with you, hear your whole
            story, and guide you through the VA disability process step by step.
          </p>

          <div className="mt-10 flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:gap-8" data-id="element-54" data-mp="2hincujl6smm0">
            <BookButton data-id="element-55" data-mp="2ll0eavswhycz" />
            <a href="#how-it-works" className="inline-flex items-center gap-2 text-lg font-medium text-paper underline decoration-gold/70 underline-offset-[6px] transition-colors duration-150 ease-out hover:text-gold" data-id="element-56" data-mp="2lk8uei8o1p2j">
              See how it works
              <ArrowDownIcon aria-hidden="true" className="h-5 w-5" data-id="element-57" data-mp="id02omr47ymj" />
            </a>
          </div>

          <p className="mt-8 text-base text-paper/70" data-id="element-58" data-mp="degdmdh866py">
            No pressure. No call center. A veteran on the other end of the line.
          </p>
        </Reveal>
      </div>
    </section>;
}